import Vue from 'vue';
import Router from 'vue-router';
import ReOrder from "./views/Re-Order.vue";
import Home from "./views/Home.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from './layout/MainFooter.vue';
import PageNotFound from './views/PageNotFound.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import ForgottenPassword from './views/ForgottenPassword.vue';
import LocationMenu from './views/LocationMenu.vue';
import ResetPassword from './views/ResetPassword.vue';
import Account from './views/Account.vue';
import Checkout from './views/Checkout.vue';
import Tracking from './views/Tracking.vue';
import Cart from './views/Cart.vue';
import TermsAndConditions from './views/TermsAndConditions.vue';
import ContactUS from './views/ContactUs';
import { ifNotAuthenticated, ifAuthenticated } from '@/middleware/auth'
import notExist from "./views/errors/401.vue";

//--- to resolve issue : NavigationDuplicated Navigating to current location (“/foo) is not allowed
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router)

const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: { default: Home, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 200, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/login",
      name: "login",
      components: { default: Login, header: MainNavbar, footer: MainFooter },
      beforeEnter: (to, from, next) => {
        ifNotAuthenticated(to, from, next);
      },
      props: {
        header: { colorOnScroll: 100, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/404",
      name: "page-not-found",
      component: PageNotFound,
    },
    {
      path: "/register",
      name: "register",
      components: { default: Register, header: MainNavbar, footer: MainFooter },
      beforeEnter: (to, from, next) => {
        ifNotAuthenticated(to, from, next);
      },
      props: {
        header: { colorOnScroll: 100, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/forgotten-password",
      name: "forgotten-password",
      components: {
        default: ForgottenPassword,
        header: MainNavbar,
        footer: MainFooter,
      },
      beforeEnter: (to, from, next) => {
        ifNotAuthenticated(to, from, next);
      },
      props: {
        header: { colorOnScroll: 100, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/auth/reset-password",
      name: "reset-password",
      component: ResetPassword,
    },
    {
      path: "/account",
      name: "account",
      beforeEnter: (to, from, next) => {
        ifAuthenticated(to, from, next);
      },
      components: { default: Account, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 160, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/menu",
      name: "menu",
      components: {
        default: LocationMenu,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 340, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/checkout",
      name: "checkout",
      components: { default: Checkout, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0, transparent: false },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/cart",
      name: "cart",
      components: { default: Cart, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0, transparent: false },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/termsandconditions/:doc?",
      name: "termsandconditions",
      components: {
        default: TermsAndConditions,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0, transparent: false },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/re-order",
      name: "re-order",
      components: {
        default: ReOrder,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 160, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/contactus",
      name: "contactus",
      components: {
        default: ContactUS,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 298, transparent: true },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/order/:id/tracking",
      name: "tracking-order",
      components: { default: Tracking, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0, transparent: false },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/not-exist",
      name: "notExist",
      components: {
        default: notExist,
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if(to.name != "checkout")
    localStorage.setItem("saved-order", null);

  next();
});
export default router